module.exports = __webpack_public_path__ + "img/user.40c1c22c.png";